import React from 'react';
import { Alert, Form, FormInstance, Input, message, Modal, Space, Typography } from 'antd';
import { FilterOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface SyncRangesModalProps {
  visible: boolean;
  form: FormInstance;
  syncing: boolean;
  onClose: () => void;
  onExecuteSync: (filters: { resolution_number?: string; prefix?: string }) => void;
}

export const SyncRangesModal: React.FC<SyncRangesModalProps> = ({
  visible,
  form,
  syncing,
  onClose,
  onExecuteSync
}) => {
  return (
    <Modal
      title={
        <Space>
          <FilterOutlined style={{ color: '#1677ff' }} />
          <span>Sincronizar Rango desde Factus</span>
        </Space>
      }
      open={visible}
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={syncing}
      destroyOnHidden
    >
      <Alert
        type="warning"
        showIcon
        message="Filtro Obligatorio para Bolsa Compartida"
        description="Dado que esta empresa opera con una bolsa de folios compartida, debes ingresar obligatoriamente el número de resolución DIAN o el prefijo para importar únicamente los rangos autorizados de esta empresa y evitar mezclar rangos con otras empresas."
        style={{ marginBottom: 16 }}
      />
      <Form
        form={form}
        layout="vertical"
        onFinish={(values) => {
          const resVal = values.resolution_number?.trim();
          const prefVal = values.prefix?.trim();
          if (!resVal && !prefVal) {
            message.warning('Debes ingresar al menos el prefijo o el número de resolución DIAN para sincronizar.');
            return;
          }
          onExecuteSync(values);
        }}
      >
        <Form.Item
          name="resolution_number"
          label="Número de Resolución DIAN"
          tooltip="Número oficial del formulario 1876 de la DIAN"
        >
          <Input placeholder="Ej. 18760000001" allowClear />
        </Form.Item>

        <Form.Item
          name="prefix"
          label="Prefijo DIAN"
          tooltip="Prefijo autorizado por la DIAN (ej. SETP, FE - Máx. 4 caracteres)"
          rules={[{ max: 4, message: 'El prefijo no puede superar los 4 caracteres' }]}
        >
          <Input placeholder="Ej. SETP" maxLength={4} style={{ textTransform: 'uppercase' }} allowClear />
        </Form.Item>

        <Text type="secondary" style={{ fontSize: 12 }}>
          * Es obligatorio diligenciar al menos uno de los dos campos anteriores.
        </Text>
      </Form>
    </Modal>
  );
};
